import { METRIC_NAME_MONITOR_JS_LOAD_TIME } from '@/constants/index.ts';
import { reportDeferred } from '@/utils/metricHelper.ts';

export const monitorSingleJsLoadTime = (keyword: string, assistName: string, assistKeyword?: string) => {
  if (!window.performance || !window.performance.getEntriesByType) return;
  const scriptEntries = window.performance.getEntriesByType('resource')
    .filter(entry => (entry as PerformanceResourceTiming).initiatorType === 'script');
  scriptEntries.forEach(entry => {
    const jsName = entry?.name?.split('/')?.slice(-1)?.[0] || '';
    if ((jsName.includes(keyword) && entry.name.includes(assistName))) {
      reportDeferred({
        metric_name: METRIC_NAME_MONITOR_JS_LOAD_TIME,
        tags: { type: 'mjlt', url: entry.name, name: assistKeyword || jsName },
        value: Number(entry.duration.toFixed(2) || 0),
        message: 'monitorJsLoadTime',
        params: JSON.parse(JSON.stringify(entry || {}))
      })
    }
  });
};